module.exports = __webpack_public_path__ + "static/media/July2022Newsletter.af407252.pdf";